import { Paper, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  '&:hover': {
    background: '#004F71',
    color: theme?.palette?.common?.white
  },
  '&:active': {
    border: '0.125rem solid #004F71',
    background: 'transparent',
    color: '#004F71'
  }
}));

export const TypographyStyledBlack = styled(Typography)(({ theme }) => ({
  color: theme?.palette?.common?.black,
  fontSize: '1.125rem',
  fontWeight: 420,
  '&:hover': { cursor: 'pointer' }
}));

export const LinkStyled = styled(Link)(() => ({
  color: '#002A3A',
  fontSize: '1.625rem',
  fontWeight: 450,
  fontFamily: 'BrandonGrotesqueRegular',
  textDecoration: 'none',
  '&:hover': {
    background: '#004F71',
    p: {
      color: '#fff'
    }
  },
  '&:active': {
    border: '0.125rem solid #004F71',
    background: 'transparent',
    p: {
      color: '#004F71'
    }
  }
}));
